import { combineReducers } from 'redux';
import { loggedReducer } from './logged/loggedReducer';
import { loginModalReducer } from './loginModal.js/loginModalReducer';
import { productTypeReducer } from "./productType/productTypeReducer";
import { countDataReducer } from './countData/countDataReducer';
import { serviceFeeReducer } from './serviceFee/serviceFeeReducer';

const rootReducer = combineReducers({
    logged: loggedReducer,
    loginModal: loginModalReducer,
    productType: productTypeReducer,
    countData: countDataReducer,
    serviceFee: serviceFeeReducer
});

export default rootReducer;